import React from "react";
import "./Avatar.scss";

// Fontaine M25 — Skeleton: loading placeholders that keep the final layout (V2 `skeleton-card`).
// Shapes: text lines, block (image), circle (avatar), and the two composites the app repeats: card and row.

/**
 * @param {"text"|"block"|"circle"|"card"|"row"} [shape="text"]
 * @param {number} [lines=3]                text: number of lines (last one shorter)
 * @param {string|number} [width] / [height]   block / circle size (CSS length)
 * @param {number} [count=1]                repeat the shape
 */
export default function Skeleton({ shape = "text", lines = 3, width, height, count = 1, className = "", ...rest }) {
  const items = Array.from({ length: Math.max(1, count) });
  const style = width != null || height != null ? { "--ft-skel-w": typeof width === "number" ? `${width}px` : width, "--ft-skel-h": typeof height === "number" ? `${height}px` : height } : undefined;
  const one = (key) => {
    if (shape === "card") {
      return (
        <div key={key} className="ft-skel-card">
          <div className="ft-skel ft-skel--block ft-skel-card__media" />
          <div className="ft-skel-card__lines">
            <div className="ft-skel ft-skel--line ft-skel--w60" />
            <div className="ft-skel ft-skel--line ft-skel--w90" />
            <div className="ft-skel ft-skel--line ft-skel--w40" />
          </div>
        </div>
      );
    }
    if (shape === "row") {
      return (
        <div key={key} className="ft-skel-row">
          <div className="ft-skel ft-skel--circle ft-skel-row__avatar" />
          <div className="ft-skel-row__lines">
            <div className="ft-skel ft-skel--line ft-skel--w50" />
            <div className="ft-skel ft-skel--line ft-skel--w80" />
          </div>
          <div className="ft-skel ft-skel--line ft-skel-row__end" />
        </div>
      );
    }
    if (shape === "text") {
      return (
        <div key={key} className="ft-skel-text">
          {Array.from({ length: Math.max(1, lines) }).map((_, i) => (
            <div key={i} className={`ft-skel ft-skel--line${i === lines - 1 && lines > 1 ? " ft-skel--w60" : ""}`} />
          ))}
        </div>
      );
    }
    // eslint-disable-next-line no-restricted-syntax -- TODO(M02): caller-supplied placeholder size via custom properties
    return <div key={key} className={`ft-skel ft-skel--${shape === "circle" ? "circle" : "block"}`} style={style} />;
  };
  return (
    <div className={["ft-skeleton", className].filter(Boolean).join(" ")} role="status" aria-label="Loading" aria-busy="true" {...rest}>
      {items.map((_, i) => one(i))}
    </div>
  );
}
